export default "__VITE_ASSET__dNusGlUa__"